// extracted by mini-css-extract-plugin
module.exports = {"header":"AVHeader_header__Ierhc","video-tabs":"AVHeader_video-tabs__rX8vL","active":"AVHeader_active___u6Wq"};